


<div
class="py-4"
[ngClass]="{ 'dir-ltr': lang == 'en' }"
>


   <div class="px-4">
      <p-skeleton width="30%" height="1.5rem" styleClass="mb-2"></p-skeleton>
   </div>
   
   
   <div class="custom-skeleton p-4 row row-cols-2 row-cols-lg-4 row-cols-md-3">
      
      <!-- #card -->
      <div>
         <p-skeleton width="100%" height="150px"></p-skeleton>
         
         <div class="flex mb-3 mt-2">
            <p-skeleton width="85%" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="70%" height="1.3rem" styleClass="mb-2"></p-skeleton>
         </div>
      </div>
   
      <!-- #card -->
      <div>
         <p-skeleton width="100%" height="150px"></p-skeleton>
         
         <div class="flex mb-3 mt-2">
            <p-skeleton width="85%" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="70%" height="1.3rem" styleClass="mb-2"></p-skeleton>
         </div>
      </div>
   
   
      <!-- #card -->
      <div>
         <p-skeleton width="100%" height="150px"></p-skeleton>
         
         <div class="flex mb-3 mt-2">
            <p-skeleton width="85%" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="70%" height="1.3rem" styleClass="mb-2"></p-skeleton>
         </div>
      </div>
      
   
      <!-- #card -->
      <div>
         <p-skeleton width="100%" height="150px"></p-skeleton>
         
         <div class="flex mb-3 mt-2">
            <p-skeleton width="85%" height="1.4rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="70%" height="1.3rem" styleClass="mb-2"></p-skeleton>
         </div>
      </div>
   
   </div>


</div>
